import { Component, OnInit } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { CouponsService } from '../../services/coupons/coupons.service';
import { NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CouponsComponent implements OnInit {
  coupons: any = [];
  keys: any = [];
  formGroup:FormGroup;
  itemName: any = [];
  itemDetails: any = [];
  constructor(private as: CouponsService,private modalService: NgbModal,private fb:FormBuilder) {
    this.as.getCoupons(1).subscribe((res) => {
      if (res.status == true) {
        this.coupons = res.data;
      }
    })
  }
  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
  }
  ngOnInit() {}
  couponsEdit(item,content){
    this.formGroup=this.fb.group({data:item})
    this. open(content);
    this.itemDetails=item
  }
  onPageChange(page){
    this.as.getCoupons(page).subscribe((res) => {
      if (res.status == true) {
        this.coupons = res.data;
      }
    })
  }
  onUpdate(content){
    // this.users[this.itemDetails[0]]=Number(this.formGroup.value.data); 
    // this.as.putAssumption(this.assumptions,this.assumptions._id).subscribe((res) => {
    //   if (res.success == true) {
    //     this.keys=Object.keys(res.data);
    //     this.keys=this.keys.filter((item)=>{
    //         return item!="__v" && item!="_id";
    //     })
    //     this.keys.forEach(item => {
    //       this.itemName.push(item.replace(/_/g," "))
    //     });
    //     this.assumptions = res.data;
    //   }
    // });
  }
}
